export enum DashboardsUpdatesType {
  DisabledContractors = 'disabled_contractors',
  WaitingForApproval = 'waiting_for_approval',
  FailedPayments = 'failed_payments',
}
